namespace $.$$ {

	$mol_style_define($bog_formigo_app, {

		font: {
			family: 'inherit',
		},

	})

}
